"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScaleProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _context = require("./context");
var _useScale = require("./useScale");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ScaleProvider = /*#__PURE__*/(0, _react.memo)(({
  value,
  children
}) => {
  const scale = (0, _useScale.useScale)();
  return /*#__PURE__*/_react.default.createElement(_context.ScaleContext.Provider, {
    value: value !== null && value !== void 0 ? value : scale
  }, children);
});
exports.ScaleProvider = ScaleProvider;
ScaleProvider.displayName = 'ScaleProvider';